<div class="icon-button--container">
  <div [ngStyle]="additionStyle" class="icon-button--icon {{active ? 'active' : ''}}">
    <img *ngIf="!active; else activeIcon" [src]="icon" alt="icon" />
  </div>
  <span class="icon-button--label">
    {{label}}
  </span>
</div>

<ng-template #activeIcon>
  <img [src]="iconActive" alt="icon" />
</ng-template>